import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import { useFormContext } from "@rvf/react-router";

import {
  Alert,
  AlertDetailItem,
  AlertDetailsList,
  AlertTitle,
} from "~/components/ui/alert";

export const FormErrors = () => {
  const state = useFormContext();
  if (!state) throw new Error("FormErrors must be used within a FormContext");

  if (state.formState.hasBeenSubmitted && !state.formState.isSubmitting) {
    const errors = Object.entries(state.formState.fieldErrors);
    if (!errors.length) return null;

    return (
      <Alert className="my-6" variant="error">
        <ExclamationTriangleIcon className="h-4 w-4" />
        <AlertTitle>
          There were {errors.length} errors with your submission
        </AlertTitle>
        <AlertDetailsList>
          {errors.map(([field, message], i) => (
            <AlertDetailItem key={i} name={field}>
              {message}
            </AlertDetailItem>
          ))}
        </AlertDetailsList>
      </Alert>
    );
  }
  return null;
};
